module.exports = __webpack_public_path__ + "static/img/8.3521510.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/1/eng/8.png
// module id = /LUO
// module chunks = 0